module.exports = __webpack_public_path__ + "img/logo.6137854d.png";